<template>
  <div
    class="widget-header"
    :style="{ background: color }"
  >
    <div class="subhead-semi-bold-16 lh-20 white--text">
      {{ text }}
    </div>

    <widget-button
      class="mr-n2"
      is-icon-only
      view="transparent"
      size="36"
      @click="$emit('close')"
    >
      <widget-icon
        class="text-white"
        name="close"
        size="24px"
      />
    </widget-button>
  </div>
</template>

<script lang="ts">
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  components: {
    WidgetIcon,
    WidgetButton,
  },
  props: {
    text: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  emits: {
    close: () => true,
  },
})
</script>

<style lang="scss" scoped>
.widget-header {
  padding: 0 16px;
  border-radius: $border-radius-md $border-radius-md 0 0;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  word-break: break-word;
}
</style>
